import { LoadableRoute } from 'routes/utils/loadable';

export const YourAccountContainer = LoadableRoute({
  loader: () => import(/* webpackChunkName: "YourAccount" */ './YourAccount'),
});
